<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   
           </div>
        </div>
    </div>
    <div class="membership-hero-section cf">
        <div class="container">
            <div class="membership-hero-detail cf">
                <div class="titel-box">
                    <h2 class="titel-name">Membership</h2>
                </div>
                <div class="membership-top-main-section cf">
                    <div class="membership-top-main-detail">
                        <div class="membership-top-main-detail-left">
                            <p>{{memberSingle?.title}}</p>
                            <h4>{{memberSingle?.subtitle}}</h4>
                        </div>
                        <div class="membership-top-main-detail-right">
                            <a href="{{memberSingle?.redirect_url}}" target="_blank">{{memberSingle?.button_name}}</a>
                        </div>
                    </div>
                    <div class="membership-top-main-content" [innerHTML]="memberSingle?.description">
                       
                    </div>
                </div>
                <div class="membership-top-detail">
                    <div *ngFor="let membership of membershipList?.data" >
                        <div class="membership-top-box" *ngIf="memberSingle?.slug != membership?.slug"  >
                            <a [routerLink]="['/membership-single', membership?.slug]" >
                                <p>{{membership?.title}}</p>
                                <h4>{{membership?.subtitle}}</h4>
                            </a>
                        </div>
                    </div>
                    <!-- <div class="membership-top-box">
                        <p>2021 Membership - On Sale Now</p>
                        <h4>Club Membership</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Membership - On Sale Now</p>
                        <h4>David Gower Executive Membership</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Membership - On Sale Now</p>
                        <h4>Junior Membership</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Membership - On Sale Now</p>
                        <h4>Introduce a friend and earn £25*</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Membership - On Sale Now</p>
                        <h4>T20 Vitality Blast details to follow</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Membership - On Sale Now</p>
                        <h4>Car Parking</h4>
                    </div> -->
                    <div class="membership-top-box membership-image">
                        <a href="javascript:void(0)"><img src="assets/images/lccc-fox-logo.svg"></a>
                    </div>
                </div>
                <!-- <div class="membership-ticket-refund">
                    <a href="javascript:void(0)"><img src="assets/images/download-ticket.png"></a>
                </div> -->
            </div>
            <div class="membership-content cf" *ngIf="contentList">
                <div class="titel-box">
                    <h2 class="titel-name">{{contentList?.title}}</h2>
                </div>
                <div class="membership-content-detail" [innerHTML]="contentList?.description">
                    <!-- <p>If there is an impact to the 2021 season, Members will always have priority access to available tickets. LCCC fans can book with confidence as all memberships are covered by our LCCC COVID GUARANTEE, which provides Members with the safety of a refund option, should current disruptions continue into the 2021 season.
                    </p> -->
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="our-partner-section cf">
        <div class="our-partner-titel">
           <div class="container">
                <div class="titel-box">
                       <h2 class="titel-name">OUR PARTNERS</h2>
                   </div>
           </div>
        </div>
        <div class="our-partner-detail cf">
            <div class="our-partner-bg"></div>
            <div class="container">
                <div class="our-partner-detail-hero">
                       <div class="our-partner-detail-hero-left">
                        <p>Official Front Of Shirt Partner</p>
                        <div class="our-partner-logo-left">
                            <img src="assets/images/img01.png">
                        </div>
                    </div>
                    <div class="our-partner-hero-right cf">
                           <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideparterConfig">
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img01.png">
                                   </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img02.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/dMU.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img05.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img02.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img01.png">
                                </div>
                            </div>
                        </ngx-slick-carousel>                
                    </div>
                </div>
            </div>  
        </div>
    </div> -->
</section><!-- page ends-->